/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Db_TriggersInputs */

const en_svchip_db_triggers = /** @type {(inputs: Svchip_Db_TriggersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DB triggers`)
};

const ar_svchip_db_triggers = /** @type {(inputs: Svchip_Db_TriggersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محفزات قاعدة البيانات`)
};

const bn_svchip_db_triggers = /** @type {(inputs: Svchip_Db_TriggersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DB ট্রিগার`)
};

const de_svchip_db_triggers = /** @type {(inputs: Svchip_Db_TriggersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DB-Trigger`)
};

const es_svchip_db_triggers = /** @type {(inputs: Svchip_Db_TriggersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activadores de base de datos`)
};

const fr_svchip_db_triggers = /** @type {(inputs: Svchip_Db_TriggersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déclencheurs de base de données`)
};

const pt_svchip_db_triggers = /** @type {(inputs: Svchip_Db_TriggersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gatilhos de banco de dados`)
};

const zh_svchip_db_triggers = /** @type {(inputs: Svchip_Db_TriggersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据库触发器`)
};

const tr_svchip_db_triggers = /** @type {(inputs: Svchip_Db_TriggersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veritabanı tetikleyicileri`)
};

const ru_svchip_db_triggers = /** @type {(inputs: Svchip_Db_TriggersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Триггеры БД`)
};

const pl_svchip_db_triggers = /** @type {(inputs: Svchip_Db_TriggersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyzwalacze DB`)
};

/**
* | output |
* | --- |
* | "DB triggers" |
*
* @param {Svchip_Db_TriggersInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_db_triggers = /** @type {((inputs?: Svchip_Db_TriggersInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Db_TriggersInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_db_triggers(inputs)
	if (locale === "bn") return bn_svchip_db_triggers(inputs)
	if (locale === "de") return de_svchip_db_triggers(inputs)
	if (locale === "es") return es_svchip_db_triggers(inputs)
	if (locale === "fr") return fr_svchip_db_triggers(inputs)
	if (locale === "pt") return pt_svchip_db_triggers(inputs)
	if (locale === "zh") return zh_svchip_db_triggers(inputs)
	if (locale === "tr") return tr_svchip_db_triggers(inputs)
	if (locale === "ru") return ru_svchip_db_triggers(inputs)
	if (locale === "pl") return pl_svchip_db_triggers(inputs)
	return en_svchip_db_triggers(inputs)
});